
import MDTypography from './MDTypography';


export function DataGridHeader(props) {
    return (
        <MDTypography  color="text" variant="button" sx={{fontWeight: 'medium', fontSize:'12px'}} > {props.children}</MDTypography>
    );
}
  
export default DataGridHeader;
